<div class="w-full max-w-[720px]">
    <div class="details-heading border-divider flex items-center justify-between border-b px-6 py-4">
        <div>
            <h2 id="time-tracking-details-title">{{ 'timeTracker.detailsTitle' | transloco }}</h2>
            <div class="text-muted text-xs">{{ now | date: 'EEEE, dd.MM.yyyy' }}</div>
        </div>
        <button mat-icon-button (click)="close()" [attr.aria-label]="'timeTracker.close' | transloco">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="space-y-6 p-6">
        <div class="grid grid-cols-2 gap-4 md:grid-cols-4">
            <div class="details-metric rounded-2xl p-3">
                <div class="text-muted text-xs">{{ 'timeTracker.status' | transloco }}</div>
                <div class="mt-1 flex items-center gap-2 font-medium">
                    <span
                        class="h-2.5 w-2.5 rounded-full"
                        [ngClass]="{
                            'bg-emerald-500': time.isRunning() && !time.isPaused(),
                            'bg-amber-500': time.isPaused(),
                            'bg-zinc-400': !time.isRunning() && !time.isPaused(),
                        }"
                    ></span>
                    <span>{{
                        (time.isPaused()
                            ? 'timeTracker.states.paused'
                            : time.isRunning()
                              ? 'timeTracker.states.running'
                              : 'timeTracker.states.inactive'
                        ) | transloco
                    }}</span>
                </div>
            </div>

            <div class="details-metric rounded-2xl p-3">
                <div class="text-muted text-xs">{{ 'timeTracker.workTime' | transloco }}</div>
                <div class="mt-1 tabular-nums text-lg">{{ time.formatHMS(time.elapsedSeconds()) }}</div>
            </div>

            <div class="details-metric rounded-2xl p-3">
                <div class="text-muted text-xs">{{ 'timeTracker.pause' | transloco }}</div>
                <div class="mt-1 tabular-nums">{{ time.formatHMS(time.totalPauseSeconds()) }}</div>
            </div>

            <div class="details-metric rounded-2xl p-3">
                <div class="text-muted text-xs">{{ 'timeTracker.today' | transloco }}</div>
                <div class="mt-1 tabular-nums">{{ now | date: ('common.date.angularFormat' | transloco) }}</div>
            </div>
        </div>

        <div class="details-actions flex flex-wrap gap-2">
            @if (!time.isRunning() && !time.isPaused()) {
                <button
                    mat-raised-button
                    color="primary"
                    (click)="time.start()"
                    [disabled]="time.isRunning() || time.isPaused() || time.apiLoading()"
                >
                    <mat-icon class="mr-2">play_arrow</mat-icon>
                    {{ 'timeTracker.start' | transloco }}
                </button>
            }
            @if (time.isRunning()) {
                <button
                    mat-raised-button
                    color="warn"
                    (click)="time.pause()"
                    [disabled]="!time.isRunning() || time.apiLoading()"
                >
                    <mat-icon class="mr-2">pause</mat-icon>
                    {{ 'timeTracker.pause' | transloco }}
                </button>
            }
            @if (time.isPaused()) {
                <button
                    mat-raised-button
                    color="primary"
                    (click)="time.resume()"
                    [disabled]="!time.isPaused() || time.apiLoading()"
                >
                    <mat-icon class="mr-2">play_circle</mat-icon>
                    {{ 'timeTracker.continue' | transloco }}
                </button>
            }
            @if (time.isRunning()) {
                <button
                    mat-stroked-button
                    (click)="time.stop()"
                    [disabled]="time.isPaused() || !time.isRunning() || time.apiLoading()"
                >
                    <mat-icon class="mr-2">stop</mat-icon>
                    {{ 'timeTracker.stop' | transloco }}
                </button>
            }
        </div>

        <!--<div class="text-xs text-muted">
            {{ 'timeTracker.futureHint' | transloco }}
        </div>-->
    </div>
</div>
